import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip, IconButton } from '@material-ui/core';
import UseFetchData from "../../../hooks/UseFetchData";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateActivities from "./CreateActivities";

const useStyles = makeStyles({
  header: {
    width: "100%",
    background: "#e6d8d8",
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8",
    color: "#3d3d3d",
    height: "2.9rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  root: {
    marginLeft: 9,
    marginRight: 9,
    height: "3.6cm",
    marginBottom: 4,
  },
  root0: {
    marginLeft: 5,
    marginRight: 5,
  },
  root1: {
    flexGrow: 1,
  },
  root2: {
    marginLeft: 2,
    marginRight: 2,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ActivityView({ ActivityType, RefDocumentID, setActivityCount, AccountID, AccountName, ActivityData, PopulateData }) {
  const classes = useStyles();
  const [response, fetchData] = UseFetchData();
  const [TileData, setTileData] = useState([]);
  const [returnData, setreturnData] = useState();
  const [ActivityID, setActivityID] = useState('');
  const [DisableCustomer, setDisableCustomer] = useState(false);
  const [DisableContact, setDisableContact] = useState(false);
  const [DisableRefDoc, setDisableRefDoc] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const PopulateActivityData = (ActivityType) => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("RefDocumentID", RefDocumentID);
    bodyFormData.append("ActivityType", ActivityType);
    fetchData("Activity/List", bodyFormData);
  }

  useEffect(() => {
    PopulateActivityData(ActivityType);
    if (ActivityType === "Lead") {
      setDisableCustomer(true);
      setDisableContact(false);
      setDisableRefDoc(true);

    }
    else if (ActivityType === "Opportunity") {
      setDisableCustomer(true);
      setDisableContact(false);
      setDisableRefDoc(true);
    }
    else if (ActivityType === "Quotation") {
      setDisableCustomer(true);
      setDisableContact(false);
      setDisableRefDoc(true);
    }
    else if (ActivityType === "SalesOrder") {
      setDisableCustomer(true);
      setDisableContact(false);
      setDisableRefDoc(true);
    }
  }, []);

  useEffect(() => {
    if (ActivityData !== undefined && ActivityData.length > 0) {
      setActivityCount(ActivityData.length);
      setTileData(ActivityData);
      setreturnData(
        ActivityData.map(i => {
          return (
            <Card className={classes.root} elevation={4}>
              <CardContent className={classes.root2}>
                <Grid container >
                  <Grid item xs={5}>
                    {i.ActivityDate}
                  </Grid>
                  <Grid item xs={4}>
                    PhoneCall: {i.ActivityCategory}
                  </Grid>
                  <Grid item xs={2}>
                    <h4 style={{ color: "rgb(0, 144, 64)" }}>{i.Status}</h4>
                  </Grid>
                  <Grid item xs={1} style={{ float: 'right' }}>
                    <Tooltip title="Edit Activity">
                      <IconButton size="small" style={{ marginTop: -7, marginLeft: 16 }} onClick={() => { setOpen(true); setActivityID(i.id) }}><EditIcon color='primary' fontSize='small' /></IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={5} style={{ fontWeight: 'bold' }}>
                    Customer Name:
                  </Grid>
                  <Grid item xs={7}>
                    {i.AccountName}
                  </Grid>
                  <Grid item xs={5}>{i.ContactName}</Grid>
                  <Grid item xs={3}>
                    {i.Phone}
                  </Grid>
                  <Grid item xs={12} container direction="row">
                    <Grid item xs={3} style={{ fontWeight: 'bold' }}>Description:</Grid>
                    <Grid item xs={9}>{i.Description}</Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          );
        })
      );
    }
  }, [ActivityData]);

  /* useEffect(() => {
    if (response !== undefined && response.length > 0) {
      setActivityCount(response.length);
      setTileData(response);
      setreturnData(
        response.map(i => {
          return (
            <Card className={classes.root} elevation={4}>
              <CardContent className={classes.root2}>
                <Grid container >
                  <Grid item xs={5}>
                    {i.ActivityDate}
                  </Grid>
                  <Grid item xs={4}>
                    PhoneCall: {i.ActivityCategory}
                  </Grid>
                  <Grid item xs={2}>
                    <h4 style={{ color: "rgb(0, 144, 64)" }}>{i.Status}</h4>
                  </Grid>
                  <Grid item xs={1} style={{ float: 'right' }}>
                    <Tooltip title="Edit Activity">
                      <IconButton size="small" style={{ marginTop: -7, marginLeft: 16 }} onClick={() => { setOpen(true); setActivityID(i.ActivityID) }}><EditIcon color='primary' fontSize='small' /></IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={5} style={{ fontWeight: 'bold' }}>
                    Customer Name:
                  </Grid>
                  <Grid item xs={7}>
                    {i.AccountName}
                  </Grid>
                  <Grid item xs={5}>{i.ContactName}</Grid>
                  <Grid item xs={3}>
                    {i.Phone}
                  </Grid>
                  <Grid item xs={12} container direction="row">
                    <Grid item xs={3} style={{ fontWeight: 'bold' }}>Description:</Grid>
                    <Grid item xs={9}>{i.Description}</Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          );
        })
      );
    }
  }, [response]); */

  return (
    <div style={{ height: 160, overflow: "scroll", overflowX: "hidden" }}>
      {returnData}
      <ModalFrame
        title="Activity Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateActivities
          ActivityID={ActivityID}
          ActivityType={ActivityType}
          AccountID={AccountID}
          AccountName={AccountName}
          PopulateData={PopulateData}
          setOpen={setOpen}
          DisableUpdate={false}
          DisableComplete={false}
          DisableDelete={false}
          DisableLink="flex"
          DisableCustomer={DisableCustomer}
          DisableContact={DisableContact}
          DisableRefDoc={DisableRefDoc}
        />
      </ModalFrame>
    </div>
  );
}
